import { Box, Code, Grid } from '@workos-inc/design-system';
import * as React from 'react';
const EnumRoot = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const childrenCount = React.Children.count(children);
  return <Box mb="3" data-sentry-element="Box" data-sentry-component="EnumRoot" data-sentry-source-file="enum.tsx">
      <Grid display="inline-grid" flow="column" gapX="3" gapY="2" style={{
      gridTemplateRows: `repeat(${childrenCount > 3 ? Math.ceil(childrenCount / 2) : 1}, auto)`
    }} data-sentry-element="Grid" data-sentry-source-file="enum.tsx">
        <ul style={{
        display: 'contents'
      }}>{children}</ul>
      </Grid>
    </Box>;
};
const EnumItem = ({
  children
}: {
  children?: React.ReactNode;
}) => <li style={{
  display: 'block',
  whiteSpace: 'nowrap'
}} data-sentry-component="EnumItem" data-sentry-source-file="enum.tsx">
    <Code highContrast color="gray" size="2" data-sentry-element="Code" data-sentry-source-file="enum.tsx">
      {children}
    </Code>
  </li>;
export const Enum = {
  Root: EnumRoot,
  Item: EnumItem
};